module.exports = __webpack_public_path__ + "img/pin-orange.e945a675.svg";